<div class="follow-ups-toolbar" data-cy="my-follow-ups">
	<div class="follow-ups-toolbar-copy">
		<div class="follow-ups-toolbar-title">
			Select follow ups to complete
		</div>

		<div
			*ngIf="selectedFollowUps.length > 0"
			class="follow-ups-toolbar-selection"
		>
			{{ selectedFollowUps.length }}
			{{
				selectedFollowUps.length === 1
					? 'follow up selected'
					: 'follow ups selected'
			}}
		</div>
	</div>

	<button
		pButton
		type="button"
		icon="pi pi-check"
		label="Complete Selected"
		class="p-button-primary"
		[disabled]="selectedFollowUps.length === 0 || isCompleting"
		(click)="completeSelectedFollowUps()"
	></button>
</div>

<div *ngIf="isLoading" class="dashboard-state">
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Loading follow ups...</span>
</div>

<div
	*ngIf="!isLoading && isCompleting"
	class="dashboard-state"
>
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Completing selected follow ups...</span>
</div>

<div
	*ngIf="!isLoading && !isCompleting"
	class="follow-ups-table-wrapper"
>
	<p-table
		data-cy="follow-ups-table"
		[value]="followUps"
		[(selection)]="selectedFollowUps"
		[paginator]="true"
		[rows]="20"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
		dataKey="id"
		selectionMode="multiple"
		styleClass="dashboard-data-table"
	>
		<ng-template pTemplate="header">
			<tr>
				<th class="selection-column">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="createdDate">
					Created
					<p-sortIcon field="createdDate"></p-sortIcon>
				</th>

				<th pSortableColumn="workflowName">
					Task
					<p-sortIcon field="workflowName"></p-sortIcon>
				</th>

				<th pSortableColumn="followUpDate">
					Follow Up Date
					<p-sortIcon field="followUpDate"></p-sortIcon>
				</th>

				<th class="action-column">
					Action
				</th>
			</tr>
		</ng-template>

		<ng-template let-followUp pTemplate="body">
			<tr>
				<td class="selection-column">
					<p-tableCheckbox [value]="followUp"></p-tableCheckbox>
				</td>

				<td class="date-column">
					{{
						followUp.createdDate
							| DatePropertyTimezone: false : true
					}}
				</td>

				<td class="follow-up-task">
					{{ followUp.workflowName }}
				</td>

				<td class="date-column">
					{{
						followUp.followUpDate
							| DatePropertyTimezone: false : true
					}}
				</td>

				<td class="action-column">
					<button
						type="button"
						class="follow-up-view-link"
						title="Go to task"
						(click)="goToTask(followUp, $event)"
					>
						<span>View</span>
						<i class="pi pi-arrow-right"></i>
					</button>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="5">
					<div class="dashboard-empty-state">
						<i class="pi pi-check-circle"></i>
						<span>No follow ups</span>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
